import React from 'react';
import Header from '../Header/Header';
import './Hero.css';
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import Hearts from "../../assets/heart.png";
import Calories from "../../assets/calories.png";
import NumberCounter from "number-counter";
import { motion } from 'framer-motion';

const Hero = () => {
  const transition = {
    type: "spring",
    duration: 3
  };
  const mobile = window.innerWidth <= 768;

  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>

      {/* Left Section */}
      <div className="left-h">
        <Header />

        {/* The Best Fitness Ad */}
        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile ? '140px' : '238px' }}
            whileInView={{ left: '8px' }}
            transition={{ ...transition, type: 'tween' }}
          ></motion.div>
          <span>Your Ultimate Fitness Destination</span>
        </div>

        {/* Hero Headings */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Transform</span> Your <span></span>
          </div>
          <div>
            <span>Body & Mind</span>
          </div>

          {/* Hero Description */}
          <div>
            <span>
              Unlock your full potential with expert guidance, state-of-the-art training programs, 
              and a supportive fitness community. Your journey to strength, health, and confidence starts today.
            </span>
          </div>
        </div>

        {/* Fitness Stats */}
        <div className="figures">
          <div>
            <span>
              <NumberCounter end={200} start={150} delay="4" preFix="+" />
            </span>
            <span>Certified Trainers</span>
          </div>

          <div>
            <span>
              <NumberCounter end={1200} start={900} delay="4" preFix="+" />
            </span>
            <span>Active Members</span>
          </div>

          <div>
            <span>
              <NumberCounter end={75} start={0} delay="4" preFix="+" />
            </span>
            <span>Customized Training Plans</span>
          </div>
        </div>

        {/* Call to Action Buttons */}
        <div className="hero-buttons">
          <button className="btn">Start Your Journey</button>
          <button className="btn">Explore Programs</button>
        </div>
      </div>

      {/* Right Section */}
      <div className="right-h">
        <button className="btn">Join Now</button>

        {/* Heart Rate Monitor */}
        <motion.div
          initial={{ right: '-1rem' }}
          whileInView={{ right: '4rem' }}
          transition={transition}
          className="heart-rate"
        >
          <img src={Hearts} alt="Heart Rate Monitor" />
          <span>Heart Rate</span>
          <span>118 bpm</span>
        </motion.div>

        {/* Hero Images */}
        <img src={hero_image} alt="Hero" className="hero-image" />
        <img src={hero_image_back} alt="Hero Background" className="hero-image-back" />

        {/* Calories Burned */}
        <motion.div
          initial={{ right: '37rem' }}
          whileInView={{ right: '28rem' }}
          transition={transition}
          className="calories"
        >
          <img src={Calories} alt="Calories Burned" />
          <div>
            <span>Calories Burned</span>
            <span>245 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
